import { render, staticRenderFns } from "./AccountingAssetReport.vue?vue&type=template&id=bfa951b4&scoped=true&"
import script from "./AccountingAssetReport.vue?vue&type=script&lang=js&"
export * from "./AccountingAssetReport.vue?vue&type=script&lang=js&"
import style0 from "./AccountingAssetReport.vue?vue&type=style&index=0&id=bfa951b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa951b4",
  null
  
)

export default component.exports